import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { useAuthStore } from '@/store/auth';

export function useUnreadFeedback(): number {
  const role = useAuthStore((s) => s.getEffectiveRole());
  const { data } = useQuery({
    queryKey: ['feedback-unread'],
    queryFn: async () => {
      const res = await apiClient.get('/feedback/admin/unread_count');
      return res.data.count as number;
    },
    refetchInterval: 60_000,
    enabled: role === 'superadmin',
  });
  return data ?? 0;
}
